<div class="row">
    <div class="col-1">
    </div>
    <div class="col-10 d-none d-sm-block">
        <canvas baseChart [datasets]="bubbleChartData" [options]="bubbleChartOptions" [colors]="bubbleChartColors"
            [legend]="bubbleChartLegend" [chartType]="bubbleChartType">
        </canvas>
        <div class="arrow-background help-text">
            User slider to zoom in by filtering out top layer
            <mat-slider color="primary" [min]="sliderMin" [max]="sliderMax" step="1" (change)="sliderChange($event)"></mat-slider>
        </div>
    </div>
    <div class="d-xs-block d-sm-none help-text">
        <div>
            Tilt your phone for visulations of the Covid data (bubble chart).
        </div>
            <img class="tilt-image" src="assets/tilt-phone.gif" alt="">
    </div>
    <div class="col-1">
    </div>

</div>

<div class="row">
    <div class="col-1"></div>
    <div class="col-10">
        <mat-card>
            <mat-card-header>
                <mat-icon mat-card-avatar>health_and_safety</mat-icon>
                <mat-card-title>
                    Vaccinations
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                {{vacDosesGiven}} vaccinations provided at {{vacDosesPerHundred}} per hundred. 
                (Vaccination data updated on - {{vacUpdatedDate}})
            </mat-card-content>
        </mat-card>
        <br>
    </div>
    <div class="col-1"></div>
</div>

<div class="row">
    <div class="col-12">
        <table mat-table [dataSource]="stateWiseData" class="mat-elevation-z8">

            <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->

            <!-- Position Column -->
            <ng-container matColumnDef="state">
                <th mat-header-cell *matHeaderCellDef> State </th>
                <td mat-cell *matCellDef="let element"> {{element.state}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="active">
                <th mat-header-cell *matHeaderCellDef> Active Cases </th>
                <td mat-cell *matCellDef="let element"> {{element.active}} </td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="confirmed">
                <th mat-header-cell *matHeaderCellDef> Confirmed Cases </th>
                <td mat-cell *matCellDef="let element"> {{element.confirmed}} </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="deaths">
                <th mat-header-cell *matHeaderCellDef> Deaths </th>
                <td mat-cell *matCellDef="let element"> {{element.deaths}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>
    </div>
</div>